var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"loading-btn",attrs:{"disabled":_vm.is_loading},on:{"click":function($event){return _vm.onClick()}}},[(_vm.is_loading)?_c('img',{attrs:{"src":require("@/assets/icons/loading_white.gif"),"alt":""}}):_vm._e(),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }